import { ApplicationStore } from '@/stores/application/application.store'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

const DEFAULT_TITLE = 'USU'

function formatTitle(title?: string): string {
  return title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE
}

function formatFromRouteName(name?: RouteLocationNormalizedLoaded['name']) {
  if (!name || typeof name !== 'string') return undefined
  return name.charAt(0).toUpperCase() + name.slice(1)
}

export async function resolveMetaTitle(
  route: RouteLocationNormalizedLoaded
): Promise<string> {
  const applicationIdParam = route.params?.id
  const applicationId = Array.isArray(applicationIdParam)
    ? applicationIdParam[0]
    : applicationIdParam

  if (applicationId && typeof applicationId === 'string') {
    const application = await ApplicationStore.getApplicationById(
      applicationId
    )

    if (application?.display_name || application?.software_name) {
      return formatTitle(application.display_name ?? application.software_name)
    }
  }

  return formatTitle(formatFromRouteName(route.name))
}
